module.exports = __webpack_public_path__ + "static/media/cyrano-background.c44f9b92.png";